export function initLoadMoreNews() {
	const btn = document.getElementById('btn-load-more-news');
	if (!btn) return;

	const grid = document.getElementById('news-grid');
	const icon = btn.querySelector('.loading-icon');

	btn.addEventListener('click', async () => {
		// Disable button
		btn.disabled = true;
		icon.classList.add('animate-spin');

		// Get next page
		const currentPage = parseInt(btn.dataset.page);
		const nextPage = currentPage + 1;

		// AJAX request
		const formData = new FormData();
		formData.append('action', 'wpcore_news_load_more');
		formData.append('nonce', wpcore.nonce);
		formData.append('page', nextPage);

		try {
			const response = await fetch(wpcore.ajaxUrl, {
				method: 'POST',
				body: formData
			});

			const data = await response.json();

			if (data.success) {
				// Append new posts
				grid.insertAdjacentHTML('beforeend', data.data.html);

				// Update page number
				btn.dataset.page = nextPage;

				// Hide button if no more posts
				if (!data.data.has_more) {
					btn.style.display = 'none';
				}
			}
		} catch (error) {
			error;
		} finally {
			// Re-enable button
			btn.disabled = false;
			icon.classList.remove('animate-spin');
		}
	});
}
